const coreName = {
  BASE: 'Core',
  MAIN: undefined,

  EMAIL_APPROVE: {
    BASE: undefined,
    PAGE: undefined,
  },

  EMAIL_RESEND: {
    BASE: undefined,
    PAGE: undefined,
  },

  CREATE_USER: {
    BASE: undefined,
    PAGE: undefined,
    INFO: undefined,
  },

  SCIENCE_ID: {
    BASE: undefined,
    PAGE: undefined,
    OAUTH: undefined,
    BIND: undefined,
  },

  REGISTRATION: {
    BASE: undefined,
    PAGE: undefined,
  },

  REGISTRATION_MAIN: {
    BASE: undefined,
    PAGE: undefined,
  },

  REGISTRATION_INDIVIDUAL: {
    BASE: undefined,
    PAGE: undefined,
  },

  REGISTRATION_APPROVE: {
    BASE: undefined,
    PAGE: undefined,
  },

  RECOVERY: {
    BASE: undefined,
    PAGE: undefined,
    APPROVE: undefined,
  },

  UPDATE: {
    BASE: undefined,
    PAGE: undefined,
  },

  UPDATE_MAIN: {
    BASE: undefined,
    PAGE: undefined,
  },

  UPDATE_INDIVIDUAL: {
    BASE: undefined,
    PAGE: undefined,
  },

  UPDATE_APPROVE: {
    BASE: undefined,
    PAGE: undefined,
  },
}
coreName.MAIN = `${coreName.BASE}|Main`

coreName.CREATE_USER.BASE = `${coreName.BASE}|Create User`
coreName.CREATE_USER.PAGE = `${coreName.CREATE_USER.BASE}|Page`
coreName.CREATE_USER.INFO = `${coreName.CREATE_USER.BASE}|Info`

coreName.SCIENCE_ID.BASE = `${coreName.BASE}|Science-Id`
coreName.SCIENCE_ID.PAGE = `${coreName.SCIENCE_ID.BASE}|Page`
coreName.SCIENCE_ID.OAUTH = `${coreName.SCIENCE_ID.OAUTH}|Oauth`
coreName.SCIENCE_ID.BIND = `${coreName.SCIENCE_ID.OAUTH}|Bind`

coreName.EMAIL_APPROVE.BASE = `${coreName.BASE}|Email Approve`
coreName.EMAIL_APPROVE.PAGE = `${coreName.EMAIL_APPROVE.BASE}|Page`

coreName.EMAIL_RESEND.BASE = `${coreName.BASE}|Email Resend`
coreName.EMAIL_RESEND.PAGE = `${coreName.EMAIL_RESEND.BASE}|Page`

coreName.RECOVERY.BASE = `${coreName.BASE}|Recovery`
coreName.RECOVERY.PAGE = `${coreName.RECOVERY.BASE}|Page`
coreName.RECOVERY.APPROVE = `${coreName.RECOVERY.BASE}|Approve`

coreName.REGISTRATION.BASE = `${coreName.BASE}|Registration`
coreName.REGISTRATION.PAGE = `${coreName.REGISTRATION.BASE}|Page`

coreName.REGISTRATION_MAIN.BASE = `${coreName.BASE}|Registration Main Info`
coreName.REGISTRATION_MAIN.PAGE = `${coreName.REGISTRATION_MAIN.BASE}|Page`

coreName.REGISTRATION_INDIVIDUAL.BASE = `${coreName.BASE}|Registration Individual Info`
coreName.REGISTRATION_INDIVIDUAL.PAGE = `${coreName.REGISTRATION_INDIVIDUAL.BASE}|Page`

coreName.REGISTRATION_APPROVE.BASE = `${coreName.BASE}|Registration Approve`
coreName.REGISTRATION_APPROVE.PAGE = `${coreName.REGISTRATION_APPROVE.BASE}|Page`

coreName.UPDATE.BASE = `${coreName.BASE}|Update`
coreName.UPDATE.PAGE = `${coreName.UPDATE.BASE}|Page`

coreName.UPDATE_MAIN.BASE = `${coreName.BASE}|Update Main Info`
coreName.UPDATE_MAIN.PAGE = `${coreName.UPDATE_MAIN.BASE}|Page`

coreName.UPDATE_INDIVIDUAL.BASE = `${coreName.BASE}|Update Individual Info`
coreName.UPDATE_INDIVIDUAL.PAGE = `${coreName.UPDATE_INDIVIDUAL.BASE}|Page`

coreName.UPDATE_APPROVE.BASE = `${coreName.BASE}|Update Approve`
coreName.UPDATE_APPROVE.PAGE = `${coreName.UPDATE_APPROVE.BASE}|Page`

export default {
  ...coreName
}
